import { render, staticRenderFns } from "./IndicationForm.vue?vue&type=template&id=481855a8&scoped=true&lang=pug"
import script from "./IndicationForm.vue?vue&type=script&lang=js"
export * from "./IndicationForm.vue?vue&type=script&lang=js"
import style0 from "./IndicationForm.vue?vue&type=style&index=0&id=481855a8&prod&lang=scss"
import style1 from "./IndicationForm.vue?vue&type=style&index=1&id=481855a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481855a8",
  null
  
)

export default component.exports